import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { createCustomEvent } from '../lib/api';
import { format } from 'date-fns';

export default function AddEventModal({ open, onClose, selectedDate, onEventCreated }) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [startTime, setStartTime] = useState('09:00');
  const [endTime, setEndTime] = useState('10:00');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const dateStr = format(selectedDate || new Date(), 'yyyy-MM-dd');
      const { data } = await createCustomEvent({
        title,
        description,
        start_time: startTime,
        end_time: endTime,
        date: dateStr,
      });
      onEventCreated(data);
      setTitle('');
      setDescription('');
      setStartTime('09:00');
      setEndTime('10:00');
      onClose();
    } catch (err) {
      console.error('Failed to create event', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="rounded-sm max-w-md" data-testid="add-event-modal">
        <DialogHeader>
          <DialogTitle className="font-['Outfit'] text-xl font-bold tracking-tight">New Event</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-2">
          <div className="space-y-2">
            <Label className="text-xs font-bold uppercase tracking-[0.15em]">Title</Label>
            <Input
              data-testid="event-title-input"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Study group, Gym..."
              required
              className="rounded-sm h-10"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-xs font-bold uppercase tracking-[0.15em]">Description</Label>
            <Input
              data-testid="event-description-input"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Optional details"
              className="rounded-sm h-10"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2">
              <Label className="text-xs font-bold uppercase tracking-[0.15em]">Start</Label>
              <Input
                data-testid="event-start-time"
                type="time"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                required
                className="rounded-sm h-10"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-xs font-bold uppercase tracking-[0.15em]">End</Label>
              <Input
                data-testid="event-end-time"
                type="time"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                required
                className="rounded-sm h-10"
              />
            </div>
          </div>
          <div className="flex gap-2 pt-2">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1 rounded-sm h-10"
              data-testid="event-cancel-button"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={loading}
              className="flex-1 rounded-sm h-10"
              data-testid="event-save-button"
            >
              {loading ? 'Saving...' : 'Add Event'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
